import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { CNMedication } from 'src/app/models/cnmedication';
import { CNTreatment } from 'src/app/models/cntreatment';
import { CNTreatmentKine } from 'src/app/models/cntreatmentkine';
import { TreatmentService } from 'src/app/services/treatment.service';

@Component({
  selector: 'app-contact-kine-treatment',
  templateUrl: './contact-kine-treatment.component.html',
  styleUrls: ['./contact-kine-treatment.component.scss']
})
export class ContactKineTreatmentComponent implements OnInit {

  private theContact: CNConsultation;
  public treatment: CNTreatmentKine;

  constructor(private dialog: MatDialog, private treatments: TreatmentService) { }

  ngOnInit(): void {
  }

  @Input() set contact(contact: CNConsultation) {
    this.theContact = contact;
    let activeTreatment: CNMedication | CNTreatment;
    if (this.theContact.id === 0) {
      // new contact, search for treatment in patient current treatments
      // tslint:disable-next-line:max-line-length
      activeTreatment = Array.from(this.treatments.treatments.values()).find(treatment => (treatment instanceof CNTreatmentKine) && treatment.isActive);
    } else {
      activeTreatment = contact.treatments(CNTreatmentKine).find(treatment => treatment.isActive);
    }
    if (!activeTreatment) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Voulez-vous créer un nouveau traitement Kiné ?',
        ok: {
          label: 'Créer',
          code: 'ok'
        },
        cancel: {
          label: 'Annuler',
          code: 'cancel'
        }
      };
      const dialogRef = this.dialog.open(ValidateDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'ok') {
          // create new treatment
          this.treatment = new CNTreatmentKine();
          this.theContact.addTreatment(this.treatment);
        }
      });
    } else {
      this.treatment = activeTreatment as CNTreatmentKine;
    }
    if (this.treatment) {
      this.theContact.addTreatment(this.treatment);
    }
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

}
